import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common';
import { initCookies } from './shared/cookies';
import { initOffcanvas } from './shared/offvanvas';
import { initModvideo } from './shared/modvideo';
import { initHeaderDropdown } from './ck/header-dropdown';
import { initASwap } from './aswap';

WCAG.init();
initCommon();
initCookies();
initOffcanvas();
initModvideo();
initHeaderDropdown();
initASwap();
setTimeout(() => {
  document.documentElement.classList.remove("index-loading");
}, 50);